'use client'
import React from 'react'
import styles from './styles.module.scss'

const TextButton = (props: any) => <div className={styles.button} {...props} />

export default TextButton
